import React, { useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { IAppState } from "../../../../app/appTypes"
import LoadingSpinner from "../../../../shared/components/ui/LoadingSpinner"
import { getAssetById } from "../../../../shared/selectors/asset"
import { IFormAsset } from "../../../assets/state/assetsTypes"
import { CaseContext } from "../../../../pages/case/CasePage"
import API from "../../../../apis/contextmeeting/api"
import { withAuthHeader } from "../../../../apis/contextmeeting/withAuthHeader"
import { CaseAssetModalContext } from "./ViewAssetModal"
import { useAppDispatch } from "../../../../shared/hooks"
import { markFormCompleteAction } from "../../../addFormToCase/state/addFormToCaseActions"

interface IProps {
  assetId: string
}

const CaseFormIframeViewer: React.FC<IProps> = (props): JSX.Element => {
  const asset = useSelector((state: IAppState) => getAssetById(state, props))
  const form = asset.asset as IFormAsset
  const [formUrl, setFormUrl] = useState(null)
  const caseId = useContext(CaseContext)
  const { closeModal } = useContext(CaseAssetModalContext)
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleMessage = (event) => {
      console.log(event.data)
      if (event.data?.type === "formComplete") {
        closeModal()
        dispatch(markFormCompleteAction(caseId, form.id))
      }
      if (event.data?.type === "formSaved") {
        closeModal()
      }
    }

    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [])

  useEffect(() => {
    // I'm not doing this in a saga, as ususal, as this is really just setting a
    // state for this component and can't really be used anywhere else.
    API.get(`/cases/${caseId}/forms/${form.id}/embed`, withAuthHeader())
      .then((a) => setFormUrl(a.data.location))
  }, [])

  if (!formUrl) return <LoadingSpinner />

  return (
    <iframe className="w-full h-full" src={formUrl} />
  )
}

export default CaseFormIframeViewer
